export default "__VITE_ASSET___SpSfevh__"